export const getOriginalTime = (cuts, time) => {
  var originalTimeStamp = time;
  for (let cut of cuts) {
    if (originalTimeStamp < cut.cutStart) {
      break;
    } else {
      var duration = cut.cutEnd - cut.cutStart;
      originalTimeStamp += duration;
    }
  }
  if (isNaN(originalTimeStamp)) return time;
  return originalTimeStamp;
};
